import React from "react";


export default function HeaderComponent({title, subtitle, items}) {

    return (
        <div>
            <div
                className="elementor-element elementor-element-df61ea6 e-flex e-con-boxed e-con e-parent"
                data-id="df61ea6"
                data-element_type="container"
                data-settings='{"background_background":"classic","shape_divider_bottom":"tilt"}'
            >
                <div className="e-con-inner">
                    <div
                        className="elementor-shape elementor-shape-bottom"
                        data-negative="false"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1000 100"
                            preserveAspectRatio="none"
                        >
                            <path
                                className="elementor-shape-fill"
                                d="M0,6V0h1000v100L0,6z"
                            />
                        </svg>
                    </div>
                    <div
                        className="elementor-element elementor-element-287395a elementor-widget__width-initial elementor-widget elementor-widget-icon-box"
                        data-id="287395a"
                        data-element_type="widget"
                        data-widget_type="icon-box.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="elementor-icon-box-wrapper">
                                <div className="elementor-icon-box-content">
                                    <h1 className="elementor-icon-box-title">
                                        <span> {title} </span>
                                    </h1>
                                    <p className="text-xl mt-2">
                                        {subtitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-37ea6f4 elementor-icon-list--layout-inline elementor-align-left elementor-widget-mobile__width-inherit elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                        data-id="37ea6f4"
                        data-element_type="widget"
                        data-widget_type="icon-list.default"
                    >
                        <div className="elementor-widget-container">
                            <ul className="elementor-icon-list-items elementor-inline-items">
                                {
                                    items.map((item, index) => (
                                        <li key={index} className="elementor-icon-list-item elementor-inline-item">
                                            <a href={item.ctaURL}>
                                              {/*<span className="elementor-icon-list-icon">*/}
                                              {/*  <i aria-hidden="true" className="fas fa-tasks"/>{" "}*/}
                                              {/*</span>*/}
                                                <span className="elementor-icon-list-text">{item.text}</span>
                                            </a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}